<template>
    <v-card class="card_tile" v-if="displayTile && communitySearchObj && ypoSearchText">
        <v-flex class="card_tile__border">
            <span class="ypo-search-title">{{communityTileConstants.TITLE}}</span>
            <v-flex class="ypo-search-open-full-directory">
                <small @click="openCommunitySearchPage">{{communityTileConstants.FULL_COMMUNITY_DIRECTORY}}</small>
            </v-flex>
            <v-flex>
                <status-overlay content-height="200px" :action="loadingAction"></status-overlay>
                <v-layout v-if="hasSuggestionResults" class="result_block" column>
                    <v-flex class="result_block__row" v-for="(community, index) in communitySearchObj.searchResults"
                            :key="index.id">
                            <v-avatar>
                                <img :src="community.communityImageURL"
                                     :key="community.communityImageURL"
                                     :alt="community.communityName"
                                     :onerror="imageErrorFallback(community.communityFallBackImageURL)"
                                />
                            </v-avatar>
                        <v-flex xs12 class="result_block__info">
                                <p @click="openCommunity(community)"
                                   :class="[`result_block__info__communityName`, isHivebriteRedirectCommunity(community) && `HB_redirect_community`]">
                                    {{community.communityName }}
                                </p>
                            <p class="result_block__info__communityType">{{community.communityType}}</p>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout class="one-click-search-results" v-if="showFacets && showFacets.length && searchCompleted" column>
                    <v-flex class="one-click-search-results__item" v-for="(facet, index) in showFacets"
                            :key="index">
                        <span v-if="facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_IN)" class="one-click-search-results__item--other-label">{{facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_IN)}}&nbsp;</span>
                        <span @click="createAFilterPill(facet)" class="pointer one-click-search-results__item--label"><strong>{{ facet.name }}</strong></span>
                        <span v-if="facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_BEGINS_WITH)" class="one-click-search-results__item--other-label">&nbsp;{{facetOtherLabel(facet, globalSearchConstants.OTHER_LABEL_BEGINS_WITH)}}</span>
                    </v-flex>
                </v-layout>
                <v-layout v-if="!hasNoResults && searchCompleted" class="ypo-search-all-results">
                    <v-flex class="ypo-search-all-results__block">
                        <span class="ypo-search-all-results__view-all">{{globalSearchConstants.VIEW}} </span>
                        <span class="ypo-search-all-results__all-matching" @click="openAllMatchingCommunities">{{globalSearchConstants.ALL_MATCHING_RESULTS}}</span>
                    </v-flex>
                </v-layout>
                <v-layout v-if="hasNoResults && searchCompleted">
                    <no-results-available :message="globalSearchConstants.NO_COMMUNITY_RESULTS_AVAILABLE"></no-results-available>
                </v-layout>
            </v-flex>
        </v-flex>
    </v-card>
</template>

<script>
    import { imageErrorFallback } from "../../common/utils/utils";
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import {
        communityTileConstants,
        globalSearchConstants,
        facetLabel,
    } from "./ypoSearch.constants";
    import NoResultsAvailable from "./NoResultsAvailable";
    import { appConstant } from "../../app.constant";
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { routerNames } from "../appCommon.constants";
    import { storeMutation } from "@/store/storeMutations.constant";
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
    import { storeGetters } from "@/store/storeGetters.constant";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";


    export default {
        name: 'CommunityTile',
        data: () => ({
            communityTileConstants,
            globalSearchConstants,
            displayTile: true,
            appConstant,
            routerNames,
        }),
        props: {
            communitySearchObj: {
                required: true,
                type: Object,
            },
            ypoSearchText: {
                type: String,
                required: true,
            },
            postSelectCallback: {
                type: Function,
                required: true,
            },
            searchCompleted: {
                type: Boolean,
                required: true,
            },
        },
        components: {
            NoResultsAvailable,
            StatusOverlay,
        },
        methods: {
            ...mapActions({
                getCommunitySearchSuggestions: `ypoSearch/${storeAction.getCommunitySearchSuggestions}`,
                initiateTracking: `ypoSearch/${storeAction.initiateTracking}`,
            }),
            ...mapMutations({
                setCommunitySelectedLetterFilter: `communityDirectory/${storeMutation.setCommunitySelectedLetterFilter}`,
            }),
            facetLabel,
            facetOtherLabel(facet, expectedLabel) {
                return facet.integratedSearchName === expectedLabel ? expectedLabel : "";
            },
            imageErrorFallback,
            openCommunitySearchPage() {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    oneClickSearchText: communityTileConstants.FULL_COMMUNITY_DIRECTORY,
                    oneClickSearchType: globalSearchConstants.COMMUNITY,
                };
                sessionStorage.removeItem(appConstant.storageKeys.communityDirectoryStoredFilters);
                this.setCommunitySelectedLetterFilter();

                this.$router.push({
                    path: `/${routerNames.COMMUNITY_DIRECTORY_PAGE}`,
                });
                this.initiateTracking(trackingObject);
                gaDataLayerEvent(gtmEventName.C_Community_Search_Trigger, communityTileConstants.FULL_COMMUNITY_DIRECTORY);
            },
            openAllMatchingCommunities() {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    oneClickSearchText: globalSearchConstants.ALL_MATCHING_RESULTS,
                    oneClickSearchType: globalSearchConstants.COMMUNITY,
                };
                sessionStorage.removeItem(appConstant.storageKeys.communityDirectoryStoredFilters);
                this.setCommunitySelectedLetterFilter();

                this.$router.push({
                    path: `/${routerNames.COMMUNITY_DIRECTORY_PAGE}`,
                    query: {
                        communitySearchText: this.ypoSearchText ? this.ypoSearchText : '',
                    },
                });
                this.initiateTracking(trackingObject);
                gaDataLayerEvent(gtmEventName.C_Community_Search_Trigger, globalSearchConstants.ALL_MATCHING_RESULTS);
            },
            routeTo(path, id) {
                this.$router.push({
                    path: `/${path}/${id}`,
                });
            },
            isHivebriteRedirectCommunity(community) {
              return !!getHbRedirectByCommunityId(this.connectPlusRedirects, community.id);
            },
            openCommunity(community) {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    tileText: this.hasSuggestionResults ? community.communityName : null,
                    tileType: globalSearchConstants.COMMUNITY,
                };
                const communitySetForHbRedirect = getHbRedirectByCommunityId(this.connectPlusRedirects, community.id);
                if (communitySetForHbRedirect) {
                   window.open(communitySetForHbRedirect.redirectUrl, '_self');
                } else {
                  const type = community.communityType.toLowerCase();
                  switch (type) {
                    case communityTileConstants.GROUP:
                      this.routeTo(communityTileConstants.GROUP, community.id);
                      break;
                    case communityTileConstants.CHAPTER:
                      this.routeTo(communityTileConstants.CHAPTER, community.id);
                      break;
                    case communityTileConstants.NETWORK:
                      this.routeTo(communityTileConstants.NETWORK, community.id);
                      break;
                    case communityTileConstants.REGION:
                      this.routeTo(communityTileConstants.REGION, community.id);
                      break;
                    default:
                      break;
                  }
                  this.initiateTracking(trackingObject);
                }
            },
            createAFilterPill(facet) {
                if (this.postSelectCallback) this.postSelectCallback();
                const trackingObject = {
                    committedSearchTerm: this.ypoSearchText,
                    oneClickSearchText: this.showFacets ? facet.name : null,
                    oneClickSearchType: globalSearchConstants.COMMUNITY,
                };
                const {
                    filterKey,
                    filterValue,
                    ribbonGroupName,
                } = facet.filters[0];
                const pillFilter = {
                    ...facet.filters[0],
                    filterKey,
                    filterValue,
                    ribbonGroupName,
                    label: facetLabel(facet.name, facet.integratedSearchName, this.ypoSearchText),

                };
                sessionStorage.removeItem(appConstant.storageKeys.communityDirectoryStoredFilters);
                this.setCommunitySelectedLetterFilter();

                this.$router.push({
                    path: `/${routerNames.COMMUNITY_DIRECTORY_PAGE}`,
                    query: {
                        communityFilters: JSON.stringify({
                            CommunityType: [pillFilter],
                        }),
                        communitySearchText: this.ypoSearchText ? this.ypoSearchText : '',
                    },
                });
                this.initiateTracking(trackingObject);
                gaDataLayerEvent(gtmEventName.C_Community_Search_Trigger, facet.name);
            },
    },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
              isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
              connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
            }),
            loadingAction() {
                return this.actions[storeAction.getCommunitySearchSuggestions];
            },
            hasSuggestionResults() {
                return this.communitySearchObj && this.communitySearchObj.searchResults && this.communitySearchObj.searchResults.length > 0;
            },
            showFacets() {
                let facets = [];
                if (this.communitySearchObj &&
                    this.communitySearchObj.searchResults &&
                    this.communitySearchObj.searchResults.length > 0) {
                    if (this.communitySearchObj.searchRibbonGroup && this.communitySearchObj.searchRibbonGroup.length > 0) {
                        facets = this.communitySearchObj.searchRibbonGroup;
                    }
                return facets;
                }
            },
            hasNoResults() {
                return this.communitySearchObj &&
                    this.communitySearchObj.searchResults &&
                    this.communitySearchObj.searchResults.length <= 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .card_tile {
        text-align: left !important;
        padding: 20px 0 20px 20px;
        box-shadow: none;
        height: 100vh;
        @include breakpoint(md){
            height: unset !important;
        }

        @include breakpoint(xs) {
            border-top: 4px solid $ypo-tile-border;
        }

        &__border {
            height: 100vh;
            border-right: 1px solid $ypo-tile-border;
            @include breakpoint(xs) {
                border-right: none;

            }
            @include breakpoint(sm) {
                height: unset !important;
            }
        }
    }

    .divider {
        color: $black;
        font-weight: 500;
    }

    .one-click-search-results {
        flex-direction: column;
        @include breakpoint(sm) {
            flex-direction: row;
            flex-wrap: wrap;
        }

        &__item {
            @include breakpoint(sm) {
                border: 1px solid $ypo-cta;
                box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.2);
                margin: 6px 3px;
                padding: 6px;
                max-width: fit-content !important;
                height: 36px;
            }
            padding: 6px 15px 6px 0;
            font-family: 'Raleway', sans-serif;

            &--other-label {
                color: $black;
                font-size: 12px;
                font-family: "Noto Sans", sans-serif;
            }

            &--label {
                font-size: 14px;
                color: $ypo-cta;
                text-decoration: none;
            }
        }
    }
    .result_block {
        position: relative;
        border-bottom: 1px solid $ypo-tile-border;
        margin-right: 30px;
        margin-bottom: 10px;

        &__row {
            position: relative;
            padding-left: 60px;
            margin-bottom: 10px;
            min-height: 70px;
            align-items: center;
            display: inherit;
            transition: 0.3ms all ease;

            &:hover {
                background: $ypo-extra-light-gray;
            }

            .v-avatar {
                position: absolute;
                left: 0;
                top: 12px;
                border: 3px solid $ypo-tile-border;
                border-radius: 150px;
                overflow: hidden;
            }
        }

        &__info {
            &__communityType {
                font-weight: bold !important;
                color: $ypo-dark-gray !important;
                font-size: 12px !important;
                line-height: 20px;
                font-family: "Noto Sans", sans-serif;
                margin: 0;
            }

            &__communityName {
                display: block;
                color: $ypo-cta !important;
                font-size: 14px !important;
                font-weight: bold !important;
                letter-spacing: 0.22px;
                line-height: 20px;
                text-overflow: ellipsis;
                font-family: 'Raleway', sans-serif;
                overflow: hidden;
                cursor: pointer;
                margin: 0 !important;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }

</style>
